import di from 'di'

import find from 'lodash/find'
import { encode } from '@wittignl/js-core/utils/base64'

export default class {

    constructor(){

        this.logger = di.get('logger').child('AppSwitcherService');
        this.config = di.get('config');
        this.auth = di.get('auth');
    }

    navigate(app, path=null){

        const appConfig = find(this.config.apps, { id: app });
        if(!appConfig){
            throw `App ${app} not found`;
        }

        let url = appConfig.url;

        if(path){
            url += path;
        }

        this.logger.info(`Navigating to app ${app}`, url);

        const relayToken = this.getRelayToken();

        document.location.href = url + '?relay=' + encodeURIComponent(relayToken);
    }

    getRelayToken(){

        const session = this.auth.getSession();
        if(!session){
            throw 'No active session'
        }

        const relayData = {
            token: session.getToken(),
            expiration: session.getExpirationTime(),
            start: session.getStartTime()
        };

        return encode(JSON.stringify(relayData));
    }
}
